import { NgModule } from 'ng-metadata/core';
import {PrmReferenceEntryItem} from './referenceEntryItem.directive';

@NgModule({
    declarations: [
        PrmReferenceEntryItem,
    ],
    providers: [
        ]

})
export class ReferenceEntryModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/referenceEntry/referenceEntryItem.module.ts